import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import {  RouterModule } from "@angular/router";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { AppMaterialModule } from "./../app-material.module";
import { NgxSpinnerModule } from "ngx-spinner";
import { HttpClientModule } from "@angular/common/http";
import { NgbModalModule } from "@ng-bootstrap/ng-bootstrap";
import { ToastrModule } from "ngx-toastr";
import { AngularFontAwesomeModule } from "angular-font-awesome";
import { NavMenuComponent } from "./nav-menu/nav-menu.component";
import { FileInputModule } from "@common/file-input/file-input.module";
import { SearchFilterPipe } from "@common/pipe/search-filter.pipe";
import { MultiSearchFilterPipe } from "@common/pipe/multi-search-filter.pipe";
import { DateRangeFilterPipe } from "@common/pipe/date-range-filter.pipe";
import { SafeHtmlPipe } from '@common/pipe/safe-html-pipe';
import { SafeUrlPipe } from '@common/pipe/safe-url-pipe';
import { MobileDirective } from "@common/directive/mobile.directive";
import { FooterComponent } from "@common/footer/footer.component";
import { HeaderComponent } from "@common/header/header.component";
import { ScrollTopComponent } from "@common/scroll-top/scroll-top.component";
import { StatutoryFilterComponent } from './statutory-filter/statutory-filter.component';
import { FileDownload } from "@root/common/file-download/file-download.component";
import { PanOrFolioValidatorDirective } from "@common/directive/pan-or-folio-validator";
import { AllowCharDirective } from "@common/directive/allow-char.directive";
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { Ng5SliderModule } from "ng5-slider";
import { SwiperModule , SWIPER_CONFIG, SwiperConfigInterface} from "ngx-swiper-wrapper";

const DEFAULT_SWIPER_CONFIG: SwiperConfigInterface = {
  observer: true,
  direction: "horizontal",
  threshold: 50,
  spaceBetween: 5,
  slidesPerView: 1,
  centeredSlides: true,
};
@NgModule({
  declarations: [
    NavMenuComponent,
    FooterComponent,
    HeaderComponent,
    ScrollTopComponent,
    StatutoryFilterComponent,
    FileDownload,
    // ---Directive
    MobileDirective,
    PanOrFolioValidatorDirective,
    AllowCharDirective,
    // -----Pipe
    SearchFilterPipe,
    MultiSearchFilterPipe,
    DateRangeFilterPipe,
    SafeHtmlPipe,
    SafeUrlPipe,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    AppMaterialModule,
    AngularFontAwesomeModule,
    HttpClientModule,
    NgbModalModule,
    NgxSpinnerModule,
    FileInputModule,
    NgbModule,
    Ng5SliderModule,
    SwiperModule,
    ToastrModule.forRoot({
      positionClass: "toast-top-center",
      preventDuplicates: true,
    }),
  ],
  exports: [
    // ---- Modules
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    AppMaterialModule,
    AngularFontAwesomeModule,
    HttpClientModule,
    NgbModalModule,
    NgxSpinnerModule,
    FileInputModule,
    NgbModule,
    Ng5SliderModule,
    SwiperModule,
    // ---- Components
    NavMenuComponent,
    FooterComponent,
    HeaderComponent,
    ScrollTopComponent,
    StatutoryFilterComponent,
    FileDownload,
    // ---Directive
    MobileDirective,
    PanOrFolioValidatorDirective,
    AllowCharDirective,
    // -----Pipe
    SearchFilterPipe,
    DateRangeFilterPipe,
    MultiSearchFilterPipe,
    SafeHtmlPipe,
    SafeUrlPipe,
  ],
  
  entryComponents: [NavMenuComponent],
  providers: [
    {
      provide: SWIPER_CONFIG,
      useValue: DEFAULT_SWIPER_CONFIG
    }
  ]
})
export class AppCommonModule {}
